import { page_builder_origin } from "features/PageBuilders/PageBuilders.constants";
import { appendUrlParams } from "utils/urlUtils";

export const GJS_HOMEPAGE_BUILDER_ROUTE_KEYS = {
  update: "gjs-homepage-builder-update",
  storefront_homepage: "storefront-homepage",
};

export const GJS_HOMEPAGE_BUILDER_ROUTE_IDS = {
  [GJS_HOMEPAGE_BUILDER_ROUTE_KEYS.update]:
    "/gjs-homepage-builder/:homepageUuid/update",
  [GJS_HOMEPAGE_BUILDER_ROUTE_KEYS.storefront_homepage]: "/StorefrontHomepage",
};

export const GJS_HOMEPAGE_BUILDER_ROUTE_GENERATORS = {
  [GJS_HOMEPAGE_BUILDER_ROUTE_KEYS.update]: ({
    homepageUuid,
    templateUuid,
  }) => {
    const params = {};
    if (templateUuid) {
      params.template = templateUuid;
    }
    return appendUrlParams(
      `/gjs-homepage-builder/${homepageUuid}/update`,
      params
    );
  },
};

export const HOMEPAGE_PAGE_BUILDER_SOURCE = {
  EXLY_BUILDER: 1,
  GRAPE_JS: 2,
};

export const HP_ACTION_KEYS = {
  listener_added: "hp-listener-added",
  start_init: "hp-start-init",
  save: "hp-save",
  save_draft: "hp-save-draft",
  auto_save: "hp-auto-save",
  publish: "hp-publish",
  upload_images: "hp-upload-images",
  image_uploaded: "hp-image-uploaded",
  media_library: {
    fetch_all: "hp-media-library-fetch-all",
    fetched: "hp-media-library-fetched",
    get_preview_url: "hp-get-preview-url",
    on_get_preview_url: "hp-on-get-preview-url",
  },
  notify: "hp-notify",
  change_template: "hp-change-template",
  // sent by the builder's back button - parent navigates to the app dashboard
  exit_builder: "hp-exit-builder",
  // the shared GJS sidebar top (sales page builder plugin) posts the unprefixed action
  exit_builder_legacy: "exit-builder",
  open_settings: "hp-open-settings",
  fetch_template: "hp-fetch-template-html",
  template_fetched: "hp-template-html-fetched",
  offering_card_select_open: "offering-card-select-open", // page builder asks CT to open the offering picker modal
  offering_card_select_save: "offering-card-select-save", // CT posts the picked offering back to the page builder
  rating_setting_get: "rating-setting-get", // page builder asks CT to read the account-level show_listing_ratings setting
  rating_setting_value: "rating-setting-value", // CT posts the setting value back to the page builder
  rating_setting_update: "rating-setting-update", // page builder asks CT to persist the account-level show_listing_ratings setting
  rating_setting_updated: "rating-setting-updated", // CT confirms the setting write back to the page builder
};

export const HOMEPAGE_BUILDER_URL = `${page_builder_origin}/homepage`;

// Hash route for the "Settings" (customizations) view of TemplatePreview
export const HOMEPAGE_SETTINGS_ROUTE_PATH = "/TemplatePreview";
// Query params used to deep-link into the settings view and select the builder mode
export const HOMEPAGE_URL_QUERY_PARAMS = {
  tab: "tab",
  builder: "builder",
};

export const HOMEPAGE_BUILDER_MODE_VALUES = {
  advanced: "advanced",
};

// sessionStorage flag set when the GJS builder navigates to the settings view,
// so the settings page can go back to the exact builder history entry
export const HOMEPAGE_BUILDER_SESSION_KEYS = {
  opened_settings: "gjs_builder_opened_settings",
};

// Delay (ms) between retries while waiting for builder iframe listeners to attach
export const HOMEPAGE_INIT_RETRY_DELAY_MS = 500;

export const HOMEPAGE_BUILDER_NOTIFY_MESSAGES = {
  saving: "Saving!",
  saved: "Saved!",
  publishing: "Publishing!",
  published: "Published!",
};

export const HOMEPAGE_UPGRADE_MODAL_COPY = {
  message: "Upgrade plan to publish your page!",
  description:
    "Create customised landing pages, very extensive using Exly’s page builder tool",
  btn_text: "Upgrade plan",
};

export const HOMEPAGE_API_PREFIX = "marketing/homepage";

export const HOMEPAGE_APIS = {
  create_homepage: `${HOMEPAGE_API_PREFIX}/create`,
  get_active_homepage: `${HOMEPAGE_API_PREFIX}/active-detail`,
  get_homepage_detail: (homepageUuid) =>
    `${HOMEPAGE_API_PREFIX}/detail/${homepageUuid}`,
  update_homepage: (homepageUuid) =>
    `${HOMEPAGE_API_PREFIX}/detail/${homepageUuid}`,
  publish_homepage: (homepageUuid) =>
    `${HOMEPAGE_API_PREFIX}/publish/${homepageUuid}`,
  get_homepage_template: (homepageUuid) =>
    `${HOMEPAGE_API_PREFIX}/template/${homepageUuid}`,
};
